<template>
  <footer>
    <p>&copy; 2025 Prime Fusion Oy | All Rights Reserved</p>
    <p><router-link to="/privacy-policy">Privacy Policy</router-link></p>
  </footer>
</template>

<style>
footer {
  text-align: center;
  padding: 20px;
  background: white;
  color: #333;
  border-top: 1px solid #ddd;
}

footer a {
  color: #4A5D23;
  text-decoration: none;
  transition: 0.3s;
}

footer a:hover {
  color: #3A4D1A;
}
</style>
